import { CircularProgress as CoreCircularProgress } from '@mui/material';
import PropTypes from 'prop-types';

// because basePath and other possible props are causing React warnings
// for more info go to https://v4-0-2.material-ui.com/api/circular-progress/
function CircularProgress({
  color = 'primary',
  disableShrink = false,
  size = 40,
  thickness = 3.6,
  value = 0,
  variant = 'indeterminate',
}) {
  return (
    <CoreCircularProgress
      color={color}
      disableShrink={disableShrink}
      size={size}
      thickness={thickness}
      value={value}
      variant={variant}
    />
  );
}

CircularProgress.propTypes = {
  color: PropTypes.string,
  disableShrink: PropTypes.bool,
  size: PropTypes.number,
  thickness: PropTypes.number,
  value: PropTypes.number,
  variant: PropTypes.string,
};

export default CircularProgress;
